<div class="col-sm-12" id="pgmJourFerie" style="height: 100%; padding: 5px 0;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;" *ngIf="!tournee">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-7 fiche-client">
        <div> Gestion de l'équipe </div>
      </div>
      <button class="uppercase" id="savecont" (click)="saveFct()"> Enregistrer </button>
      <button class="uppercase btn-close" id="closeclt" (click)="fermer()"> Fermer </button>
    </div>
  </div>
  <div class="contente ligneBon col-sm-12" style="color: #000;padding: 15px; font-size: 13px;">
    <div class="col-sm-12" style="padding: 0; height: 100%;">
      <div class="col-sm-12" style="padding: 0px; height: 100%;">
        <div class="form-group items col-sm-12" style="padding:0px">
          <label class="col-sm-5 champ" style="padding:0px">
            Poste Leader :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="dataQualificationTrue" [label]="''" [isCombo]="true"
              id="modedepaie" (selectfunction)="objEquipe.qualificationLeader = $event;"
              [defaultselected]="objEquipe.qualificationLeader" [container]="true" [disablefocus]="true"
              [highlight]="true" (searchfunction)="searchQualification(true)" [dropdownclass]="'maxZindex'"
              [defaultsearch]="(objEquipe.qualificationLeader ? (objEquipe.qualificationLeader.libelleObjetEntite) : '')">
            </app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12" style="padding:0px" [ngClass]="{'disabledbutton': !objEquipe.program && !depuisEditTournee}">
          <label class="col-sm-5 champ" style="padding:0px">
            Pers. par défaut (Leader) :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="listPersodefault" [label]="''" id="modedepaie"
              [dropdownclass]="'maxZindex'" (selectfunction)="objEquipe.leaderEquipe = $event;"
              [defaultselected]="objEquipe.leaderEquipe" [showResultKeyenter]="true" [container]="true"
              [disablefocus]="true" [selectvalue]="true" [highlight]="true"
              (searchfunction)="searchPersodefault($event, objEquipe.qualificationLeader)"
              [defaultsearch]="(objEquipe.leaderEquipe ? (objEquipe.leaderEquipe.libelleObjetEntite || 'A définir') : 'A définir')">
            </app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12" style="padding:0px" *ngIf="!depuisEditTournee">
          <label class="col-sm-5 champ" style="padding:0px">
            Pers. ponctuel (Leader) :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="listPersoPonctuel" [label]="''" id="modedepaie"
              [showResultKeyenter]="true"
              (selectfunction)="objEquipe.changeChauff = true; objEquipe.chauffeur = $event;"
              [defaultselected]="objEquipe.chauffeur" [dropdownclass]="'maxZindex'" [container]="true"
              [disablefocus]="true" [selectvalue]="true" [highlight]="true"
              (searchfunction)="searchPersoPonctuel($event, objEquipe.qualificationLeader)"
              [defaultsearch]="(objEquipe.chauffeur ? (objEquipe.chauffeur.libelleObjetEntite || 'A définir') : 'A définir')">
            </app-autocomplete>
          </div>
        </div>
        <div class="addLigne col-sm-12 uppercase">
          <div class="col-sm-7 text-left">
            <button class="btn-add" id="addLigne" (click)="clickAddPost()">
              <i class="fa fa-plus"></i>
            </button>
            <span style="padding: 0 10px;" (click)="clickAddPost()">Ajouter
              poste</span>

          </div>
          <h5 class="text-right uppercase col-sm-5"> Equipiers</h5>
        </div>
        <div class="col-sm-12 ligneBon liste" style="height: calc(100% - 170px);padding: 0px;">
          <ngx-datatable style="height: 100%" class="material" [rows]="objEquipe.listePersonnelParPoste || []"
            [columnMode]="'force'" [headerHeight]="35" [footerHeight]="0" [rowHeight]="35" [selectionType]="'checkbox'"
            [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator">

            <ngx-datatable-column name="Chantier" prop="poste.qualification.libelleObjetEntite">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader text-left">
                  <span class="uppercase"> Poste </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                {{ value }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="agence.libelle">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Pers. par défaut </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <div [ngClass]="{'disabledbutton': !objEquipe.program && !depuisEditTournee}">
                  <app-autocomplete [placeholder]="''" (selectfunction)="row.personnelDefaut = $event;"
                    [results]="listPersodefault" [label]="''" [defaultselected]="row.personnelDefaut" [container]="true"
                    [showResultKeyenter]="true" [id]="'detailfact btncombo personnelDefaut' + rowIndex"
                    [disablefocus]="true" [dropdownclass]="'maxZindex'" [selectvalue]="true" [highlight]="true"
                    (searchfunction)="searchPersodefault($event, row.poste)"
                    [defaultsearch]="(row.personnelDefaut ? (row.personnelDefaut.libelleObjetEntite || 'A définir') : 'A définir')">
                  </app-autocomplete>
                </div>

              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="chauffeur.libelle" *ngIf="!depuisEditTournee">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Pers. ponctuel </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <app-autocomplete [placeholder]="''" (selectfunction)="row.chauffeur = $event;"
                  [results]="listPersoPonctuel" [label]="''" [defaultselected]="row.chauffeur" [selectvalue]="true"
                  [container]="true" [id]="'detailfact btncombo chauffeur' + rowIndex" [showResultKeyenter]="true"
                  [disablefocus]="true" [dropdownclass]="'maxZindex'" [highlight]="true"
                  (searchfunction)="searchPersoPonctuel($event, row.poste)"
                  [defaultsearch]="(row.chauffeur ? (row.chauffeur.libelleObjetEntite || 'A définir') : 'A définir')">
                </app-autocomplete>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [width]="50" [sortable]="false" [canAutoResize]="false" [draggable]="false"
              [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                <div class="text-center"><button class="btn-detail"
                    (click)="selectedPoste = row; common.openModal(modalService, confirmeSuppPoste)">
                    <i class="fa fa-trash"></i>
                  </button></div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>


    </div>
  </div>
  <div class="text-right col-sm-12 modalEquipe" style="margin-top: 15px;" *ngIf="tournee">
    <button type="button" class=" btn-close btn-valider" (click)="saveFct()"> Enregistrer </button>
    <button type="button" class=" btn-close" (click)="fermer()"> Fermer </button>
    
  </div>
</div>


<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <strong class="cofirmemsg"> {{ error }} </strong>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer </button>
    </div>
  </div>
</ng-template>


<ng-template #qualifEq>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Sélectionner la qualification </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <app-autocomplete [placeholder]="'Qualification'" (searchfunction)="searchQualification()"
        (selectfunction)="selectedQual = $event" [isCombo]="true" [ActiveFocusCombo]="true" [id]="'qualifTemporaire'"  [results]="dataQualification"
        [defaultsearch]="selectedQual ? selectedQual.libelleObjetEntite : ''" >
      </app-autocomplete>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="selectedQual"
        (click)=" common.closeModal();addLigne();">
        OK </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmeSuppPoste>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> La suppresion du/des poste(s) sera effective sur tous les
          mouvement.</label>
        <label class="cofirmemsg"> Souhaitez vous réaliser cette opération ? </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();deleteLigne(selectedPoste);">
        OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> NON </button>
    </div>
  </div>
</ng-template>